import Select2 from "./select2/Select2";
import EquipmentDevices from "../constants/EquipmentDevices";
import devicesCons from "../constants/Devices";
import { CreateEquipmentButton, ShowEquipment } from "../api/api";
import { useContext, useEffect, useRef, useState } from "react";
import "./SelectDevice.css";
import { Context } from "../context/Context";
import { useNavigate, useParams } from "react-router-dom";
import Devices from "../constants/Devices";
import ErrorToast from "./toasts/ErrorToast";
import DataLoggerProperties from "./DataLoggerProperties";

const SelectDevice = ({ mode = "single", cycleMode = false }) => {
  const [options, setOptions] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [outputStates, setOutputStates] = useState([]);
  const [readableOutputStates, setReadableOutputStates] = useState();
  const [outputsName, setOutputsName] = useState([]);
  const [devicesList, setDevicesList] = useState([]);
  const {
    setSelectedEquipment,
    setIsLoading,
    devices,
    equipmentButtons,
    setEquipmentButtons,
    setUpdate,
  } = useContext(Context);

  const navigate = useNavigate();
  const { room_id: roomId } = useParams();
  const DataLoggerPropertiesRef = useRef();

  const { equipment_id: eq_id, equipment_type: eq_type } = useParams();

  const devices_type = EquipmentDevices.find(
    (eq) => eq.type == eq_type,
  )?.devices_type;

  useEffect(() => {
    if (devices_type) {
      // setIsLoading(true);
      // DevicesList({ devices_type })
      //   .then(({ data }) => {
      //     setDevices(data.devices || []);
      //     const newOptions =
      //       data.devices?.map((device) => ({
      //         name:
      //           device.name +
      //           " / " +
      //           Devices.find((d) => d.type == device.type).prefix +
      //           " - " +
      //           device.serial,
      //         value: device.id,
      //       })) || [];
      //     setOptions(newOptions);
      //     setIsLoading(false);
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //   });

      let devs = devices.filter((device) => {
        if (eq_type == 9999) {
          return (
            devices_type.includes(Number(device.type)) &&
            (device.fw_version >= 17 ||
              (device.fw_version >= 12 && device.fw_version <= 14))
          );
        }
        return devices_type.includes(Number(device.type));
      });
      const newOptions =
        devs.map((device) => ({
          name: device.name
            ? device.name +
              " / " +
              Devices.find((d) => d.type == device.type)?.prefix +
              " - " +
              device.serial
            : "" +
              Devices.find((d) => d.type == device.type)?.prefix +
              " - " +
              device.serial,
          value: device.id,
        })) || [];

      setOptions(newOptions);

      setDevicesList(devs);
    }
  }, [devices_type, devices]);

  useEffect(() => {
    if (eq_type == 9998) {
      let device = devicesList.find((device) => device.id == selectedDevice);
      let outputs = [];
      if (device) {
        switch (device.type.toString()) {
          case "10":
            outputs = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            break;
          case "12":
            outputs = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            break;
          case "4":
            outputs = [0, 0, 0, 0];
            break;
          case "9":
            outputs = [0, 0, 0, 0];
            break;
          case "5":
            outputs = [0, 0, 0, 0];
            break;
        }
        setOutputStates(outputs);
      }
    } else if (eq_type == 9999) {
      let device = devicesList.find((device) => device.id == selectedDevice);
      let outputs = [];
      if (device) {
        switch (device.type.toString()) {
          case "10":
            outputs = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            break;
          case "12":
            outputs = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            break;
          case "4":
            outputs = [0, 0, 0, 0];
            break;
          case "9":
            outputs = [0, 0, 0, 0];
            break;
          case "5":
            outputs = [0, 0, 0, 0];
            break;
          case "3":
            outputs = [
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ];
        }
        setOutputStates(outputs);
      }
    } else if (devicesList.length && selectedDevice) {
      const equipment = EquipmentDevices.find((eq) => eq.type == eq_type);
      let NumberOfOutputs;
      if (equipment?.channel_number) {
        NumberOfOutputs = equipment.channel_number;
      } else {
        const selectedDeviceData = devicesList.find(
          (device) => device.id == selectedDevice,
        );
        NumberOfOutputs =
          devicesCons.find((device) => device.type == selectedDeviceData.type)
            ?.outputs ?? 0;
      }
      setOutputStates(new Array(NumberOfOutputs).fill(0));
    }
  }, [devicesList, selectedDevice]);

  const handleOutputClick = (index, name) => {
    if (mode === "single") {
      // مد single: فقط یک خروجی فعال باشد
      const newStates = new Array(outputStates.length).fill(0);
      newStates[index] = 1;
      setOutputStates(newStates);

      setReadableOutputStates(newStates.join("").split("").reverse().join(""));
      setOutputsName([name]);
    } else if (mode === "multi") {
      // بررسی حالت cycleMode برای انتخاب بین حالت قبلی و حالت چرخه‌ای
      const newStates = [...outputStates];

      if (cycleMode) {
        // حالت چرخه‌ای: تغییر بین state-0, state-1, state-2
        if (newStates[index] === 0) {
          newStates[index] = 1; // از حالت خاموش به حالت state-1
        } else if (newStates[index] === 1) {
          newStates[index] = 2; // از حالت state-1 به حالت state-2
        } else if (newStates[index] === 2) {
          newStates[index] = 0; // از حالت state-2 به حالت خاموش (state-0)
        }
      } else {
        // حالت قبلی: فقط خاموش/روشن
        newStates[index] = newStates[index] === 1 ? 0 : 1;
      }

      setOutputStates(newStates);

      const newNames = [...outputsName];
      if (newStates[index] === 0) {
        // حذف نام خروجی از لیست زمانی که وضعیت به 0 تغییر می‌کند
        const nameIndex = newNames.indexOf(name);
        if (nameIndex !== -1) newNames.splice(nameIndex, 1);
      } else {
        // افزودن نام خروجی به لیست در صورت فعال بودن
        if (!newNames.includes(name)) {
          newNames.push(name);
        }
      }

      setReadableOutputStates(newStates.join("").split("").reverse().join(""));
      setOutputsName(newNames);
    }
  };

  const renderOutputs = () => {
    switch (eq_type) {
      case "100":
        mode = "single";
        break;
      case "9":
        mode = "single";
        break;
      case "3":
        mode = "single";
        break;
      case "4":
        mode = "multi";
        break;
      case "501":
        mode = "single";
        break;
      case "503":
        mode = "single";
        break;
      case "401":
        mode = "multi";
        cycleMode = true;
        break;
      case "99":
        mode = "single";
        break;
      case "1":
        mode = "multi";
        break;
      case "5":
        mode = "multi";
        break;
      case "9998":
        mode = "multi";
        break;
      case "9999":
        mode = "multi";
        break;
    }
    if (eq_type == 9998) {
      let scenId = 0;
      return outputStates.map((state, index) => {
        if (outputStates.length == 16) {
          if (index < 12) {
            return (
              <div
                key={index}
                className={`output d-flex justify-content-center mt-2 ${
                  state == 1 ? "state-1" : state == 2 ? "state-2" : "state-0"
                }`}
                onClick={() => handleOutputClick(index, index + 1)}
              >
                <div style={{ alignContent: "center" }}>
                  <span>ورودی {index + 1}</span>
                </div>
              </div>
            );
          } else {
            scenId++;
            return (
              <div
                key={index}
                className={`output d-flex justify-content-center mt-2 ${
                  state == 1 ? "state-1" : state == 2 ? "state-2" : "state-0"
                }`}
                onClick={() => handleOutputClick(index, index + 1)}
              >
                <div style={{ alignContent: "center" }}>
                  <span>سناریو {scenId}</span>
                </div>
              </div>
            );
          }
        }
        if (outputStates.length == 4) {
          scenId++;
          return (
            <div
              key={index}
              className={`output d-flex justify-content-center mt-2 ${
                state == 1 ? "state-1" : state == 2 ? "state-2" : "state-0"
              }`}
              onClick={() => handleOutputClick(index, index + 13)}
            >
              <div style={{ alignContent: "center" }}>
                <span>سناریو {scenId}</span>
              </div>
            </div>
          );
        }
      });
    } else if (eq_type == 9999) {
      let scenId = 0;
      return outputStates.map((state, index) => {
        if (outputStates.length == 16) {
          if (index < 12) {
            return (
              <div
                key={index}
                className={`output d-flex justify-content-center mt-2 ${
                  state == 1 ? "state-1" : state == 2 ? "state-2" : "state-0"
                }`}
                onClick={() => handleOutputClick(index, index + 1)}
              >
                <div style={{ alignContent: "center" }}>
                  <span>ورودی {index + 1}</span>
                </div>
              </div>
            );
          } else {
            scenId++;
            return (
              <div
                key={index}
                className={`output d-flex justify-content-center mt-2 ${
                  state == 1 ? "state-1" : state == 2 ? "state-2" : "state-0"
                }`}
                onClick={() => handleOutputClick(index, index + 1)}
              >
                <div style={{ alignContent: "center" }}>
                  <span>سناریو {scenId}</span>
                </div>
              </div>
            );
          }
        }
        if (outputStates.length == 4) {
          scenId++;
          return (
            <div
              key={index}
              className={`output d-flex justify-content-center mt-2 ${
                state == 1 ? "state-1" : state == 2 ? "state-2" : "state-0"
              }`}
              onClick={() => handleOutputClick(index, index + 13)}
            >
              <div style={{ alignContent: "center" }}>
                <span>سناریو {scenId}</span>
              </div>
            </div>
          );
        }
        if (outputStates.length == 20) {
          scenId++;
          return (
            <div
              key={index}
              className={`output d-flex justify-content-center mt-2 ${
                state == 1 ? "state-1" : state == 2 ? "state-2" : "state-0"
              }`}
              onClick={() => handleOutputClick(index, index  + 1)}
            >
              <div style={{ alignContent: "center" }}>
                <span>سناریو {scenId}</span>
              </div>
            </div>
          );
        }
      });
    } else {
      return outputStates.map((state, index) => {
        if (eq_type == 99) {
          return (
            <div
              key={index}
              className={`output d-flex justify-content-center mt-2 ${
                state == 1 ? "state-1" : state == 2 ? "state-2" : "state-0"
              }`}
              onClick={() => handleOutputClick(index, "عمومی")}
            >
              <div style={{ alignContent: "center" }}>
                <span>عمومی</span>
              </div>
            </div>
          );
        } else {
          return (
            <div
              key={index}
              className={`output d-flex justify-content-center mt-2 ${
                state == 1 ? "state-1" : state == 2 ? "state-2" : "state-0"
              }`}
              onClick={() => handleOutputClick(index, index + 1)}
            >
              <div style={{ alignContent: "center" }}>
                <span>{index + 1}</span>
              </div>
            </div>
          );
        }
      });
    }
  };

  const handleChangeSelectedDevice = (newValue) => {
    setSelectedDevice(newValue);
    setReadableOutputStates(null);
    setOutputStates([]);
    setOutputsName([]);
  };

  const handleSubmitStates = () => {
    const equipmentDetail = handleGetEquipmentDetail(eq_type);
    if (!selectedDevice) {
      return ErrorToast("دستگاه مورد نظر را انتخاب کنید");
    } else if (
      outputsName.length == 0 &&
      equipmentDetail.name !== "DATA-LOGGER"
    ) {
      return ErrorToast("کانالی انتخاب نشده است");
    }
    let digits;
    let data = [];
    if (equipmentDetail.name == "TELEVESION") {
      data = [];
      digits = [];
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        digits,
        datas: data,
        type: 100,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          let buttonIndex = buttons.findIndex((eq) => eq.equipment_id == eq_id);
          if (buttonIndex !== -1) {
            buttons = buttons.map((equipment_button) =>
              equipment_button.equipment_id == eq_id
                ? {
                    ...equipment_button,
                    device_id: selectedDevice,
                    // digit: null,
                    // name: null,
                  }
                : equipment_button,
            );
            setEquipmentButtons(buttons);
          } else {
            setEquipmentButtons((prev) => [
              ...prev,
              {
                equipment_id: eq_id,
                device_id: selectedDevice,
                name: null,
                digit: null,
                data1: null,
                data2: null,
                data3: null,
                data4: null,
                data5: null,
              },
            ]);
          }
          handleCheckAccess(
            "/room/television/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "REMOTE") {
      data = [];
      digits = [];
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        digits,
        datas: data,
        type: 3,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          data.equipment_buttons.forEach((button) => {
            buttons.push({
              id: button.id,
              equipment_id: eq_id,
              device_id: selectedDevice,
              name: "R",
              digit: null,
              data1: null,
              data2: null,
              data3: null,
              data4: null,
              data5: null,
              icon: null,
            });
          });
          setEquipmentButtons(buttons);
          handleCheckAccess(
            "/room/remote/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "DIMMER") {
      data = [];
      digits = outputsName.map((out) => out - 1);
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        digits,
        datas: data,
        type: 4,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          // digits.forEach((digit, index) => {
          //   buttons.push({
          //     equipment_id: eq_id,
          //     device_id: selectedDevice,
          //     name: `D ${digit + 1}`,
          //     digit: digit,
          //     data1: null,
          //     data2: null,
          //     data3: null,
          //     data4: null,
          //     data5: null,
          //   });
          // });
          data.equipment_buttons.forEach((button) => {
            buttons.push({
              id: button.id,
              equipment_id: button.equipment_id,
              device_id: button.device_id,
              name: `D ${button.digit + 1}`,
              digit: button.digit,
              data1: null,
              data2: null,
              data3: null,
              data4: null,
              data5: null,
            });
          });
          setEquipmentButtons(buttons);
          handleCheckAccess(
            "/room/dimmer/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "RGB") {
      data = [];
      digits = outputsName.map((out) => out - 1);
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        digits,
        datas: data,
        type: 9,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          // digits.forEach((digit) => {
          //   let button = equipmentButtons.find(
          //     (eq) => eq.equipment_id == eq_id
          //   );
          //   if (button) {
          //     setEquipmentButtons((equipment_buttons) =>
          //       equipment_buttons.map((equipment_button) => {
          //         if (equipment_button.equipment_id == eq_id) {
          //           equipment_button.device_id = selectedDevice;
          //           equipment_button.digit = digit;
          //           equipment_button.name = digit + 1;
          //         }
          //         return equipment_button; // Ensure you return the correct value
          //       })
          //     );
          //   } else {
          //     setEquipmentButtons((prev) => [
          //       ...prev,
          //       {
          //         equipment_id: eq_id,
          //         device_id: selectedDevice,
          //         name: `RGB ${digit + 1}`,
          //         digit: digit,
          //         data1: null,
          //         data2: null,
          //         data3: null,
          //         data4: null,
          //         data5: null,
          //       },
          //     ]);
          //   }
          // });

          data.equipment_buttons.forEach((button) => {
            let btn = equipmentButtons.find(
              (eqbtn) =>
                eqbtn.equipment_id == button.equipment_id
                // eqbtn.device_id == button.device_id,
            );
            if (btn) {
              setEquipmentButtons((equipment_buttons) =>
                equipment_buttons.map((equipment_button) => {
                  if (
                    equipment_button.equipment_id == button.equipment_id
                    // equipment_button.device_id == button.device_id
                  ) {
                    equipment_button.device_id = button.device_id;
                    equipment_button.digit = button.digit;
                    equipment_button.name = `RGB ${button.digit + 1}`;
                  }
                  return equipment_button;
                }),
              );
            } else {
              setEquipmentButtons((prev) => [
                ...prev,
                {
                  id: button.id,
                  equipment_id: button.equipment_id,
                  device_id: button.device_id,
                  name: `RGB ${button.digit + 1}`,
                  digit: button.digit,
                  data1: null,
                  data2: null,
                  data3: null,
                  data4: null,
                  data5: null,
                },
              ]);
            }
          });
          handleCheckAccess(
            "/room/rgb/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "FAN-COIL") {
      data = [];
      digits = outputsName.map((out) => out - 1);
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        digits,
        datas: data,
        type: 501,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          // digits.forEach((digit) => {
          //   let button = equipmentButtons.find(
          //     (eq) => eq.equipment_id == eq_id
          //   );
          //   if (button) {
          //     setEquipmentButtons((equipment_buttons) =>
          //       equipment_buttons.map((equipment_button) => {
          //         if (equipment_button.equipment_id == eq_id) {
          //           equipment_button.device_id = selectedDevice;
          //           equipment_button.digit = digit;
          //           equipment_button.name = digit + 1;
          //         }
          //         return equipment_button; // Ensure you return the correct value
          //       })
          //     );
          //   } else {
          //     setEquipmentButtons((prev) => [
          //       ...prev,
          //       {
          //         equipment_id: eq_id,
          //         device_id: selectedDevice,
          //         name: digit + 1,
          //         digit: digit,
          //         data1: null,
          //         data2: null,
          //         data3: null,
          //         data4: null,
          //         data5: null,
          //       },
          //     ]);
          //   }
          // });

          data.equipment_buttons.forEach((button) => {
            let btn = equipmentButtons.find(
              (eqbtn) => eqbtn.equipment_id == button.equipment_id,
            );
            if (btn) {
              setEquipmentButtons((equipment_buttons) =>
                equipment_buttons.map((equipment_button) => {
                  if (equipment_button.equipment_id == button.equipment_id) {
                    equipment_button.device_id = button.device_id;
                    equipment_button.digit = button.digit;
                    equipment_button.name = `${button.digit + 1}`;
                  }
                  return equipment_button;
                }),
              );
            } else {
              buttons.push({
                id: button.id,
                equipment_id: button.equipment_id,
                device_id: button.device_id,
                name: `${button.digit + 1}`,
                digit: button.digit,
                data1: null,
                data2: null,
                data3: null,
                data4: null,
                data5: null,
              });
              setEquipmentButtons(buttons);
            }
          });
          handleCheckAccess(
            "/room/fan-coil/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "KEY") {
      data = [];
      digits = outputsName.map((out) => out - 1);
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        digits,
        datas: data,
        type: 1,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          // digits.forEach((digit) => {
          //   buttons.push({
          //     equipment_id: eq_id,
          //     device_id: selectedDevice,
          //     digit,
          //     name: digit + 1,
          //     data1: null,
          //     data2: null,
          //     data3: null,
          //     data4: null,
          //     data5: null,
          //   });
          // });
          data.equipment_buttons.forEach((button) => {
            buttons.push({
              id: button.id,
              equipment_id: button.equipment_id,
              device_id: button.device_id,
              digit: button.digit,
              name: button.digit + 1,
              data1: null,
              data2: null,
              data3: null,
              data4: null,
              data5: null,
              is_continual: 0,
            });
          });
          setEquipmentButtons(buttons);
          handleCheckAccess(
            "/room/key/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "MOTOR") {
      data = [];
      digits = outputsName.map((out) => out - 1);
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        digits,
        datas: data,
        type: 502,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          // digits.forEach((digit) => {
          //   let button = equipmentButtons.find(
          //     (eq) => eq.equipment_id == eq_id
          //   );
          //   if (button) {
          //     setEquipmentButtons((equipment_buttons) =>
          //       equipment_buttons.map((equipment_button) => {
          //         if (equipment_button.equipment_id == eq_id) {
          //           equipment_button.device_id = selectedDevice;
          //           equipment_button.digit = digit;
          //           equipment_button.name = digit + 1;
          //         }
          //         return equipment_button; // Ensure you return the correct value
          //       })
          //     );
          //   } else {
          //     setEquipmentButtons((prev) => [
          //       ...prev,
          //       {
          //         equipment_id: eq_id,
          //         device_id: selectedDevice,
          //         name: digit + 1,
          //         digit: digit,
          //         data1: null,
          //         data2: null,
          //         data3: null,
          //         data4: null,
          //         data5: null,
          //       },
          //     ]);
          //   }
          // });

          data.equipment_buttons.forEach((button) => {
            let btn = equipmentButtons.find(
              (eqbtn) => eqbtn.equipment_id == button.equipment_id,
            );
            if (btn) {
              setEquipmentButtons((equipment_buttons) =>
                equipment_buttons.map((equipment_button) => {
                  if (equipment_button.equipment_id == button.equipment_id) {
                    equipment_button.device_id = button.device_id;
                    equipment_button.digit = button.digit;
                    equipment_button.name = `${button.digit + 1}`;
                  }
                  return equipment_button;
                }),
              );
            } else {
              setEquipmentButtons((prev) => [
                ...prev,
                {
                  id: button.id,
                  equipment_id: button.equipment_id,
                  device_id: button.device_id,
                  name: `${button.digit + 1}`,
                  digit: button.digit,
                  data1: null,
                  data2: null,
                  data3: null,
                  data4: null,
                  data5: null,
                },
              ]);
            }
          });
          handleCheckAccess(
            "/room/motor/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "THERMOSTAT") {
      data = [];
      digits = outputsName.map((out) => out - 1);
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        digits,
        datas: data,
        type: 5,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          // digits.forEach((digit) => {
          //   buttons.push({
          //     equipment_id: eq_id,
          //     device_id: selectedDevice,
          //     digit,
          //     name: digit + 1,
          //     data1: null,
          //     data2: null,
          //     data3: null,
          //     data4: null,
          //     data5: null,
          //   });
          // });

          data.equipment_buttons.forEach((button) => {
            buttons.push({
              id: button.id,
              equipment_id: button.equipment_id,
              device_id: button.device_id,
              digit: button.digit,
              name: `T${button.digit + 1}`,
              data1: null,
              data2: null,
              data3: null,
              data4: null,
              data5: null,
            });
          });
          setEquipmentButtons(buttons);
          handleCheckAccess(
            "/room/thermostat/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "HUMIDITY") {
      data = [];
      digits = outputsName.map((out) => out - 1);
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        digits,
        datas: data,
        type: 503,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          // digits.forEach((digit) => {
          //   let button = equipmentButtons.find(
          //     (eq) => eq.equipment_id == eq_id && eq.device_id == selectedDevice
          //   );
          //   if (button) {
          //     setEquipmentButtons((equipment_buttons) =>
          //       equipment_buttons.map((equipment_button) => {
          //         if (equipment_button.equipment_id == eq_id) {
          //           equipment_button.device_id = selectedDevice;
          //           equipment_button.digit = digit;
          //           equipment_button.name = `H ${digit + 1}`;
          //         }
          //         return equipment_button; // Ensure you return the correct value
          //       })
          //     );
          //   } else {
          //     setEquipmentButtons((prev) => [
          //       ...prev,
          //       {
          //         equipment_id: eq_id,
          //         device_id: selectedDevice,
          //         name: `H ${digit + 1}`,
          //         digit: digit,
          //         data1: null,
          //         data2: null,
          //         data3: null,
          //         data4: null,
          //         data5: null,
          //       },
          //     ]);
          //   }
          // });

          data.equipment_buttons.forEach((button) => {
            let btn = equipmentButtons.find(
              (eqbtn) =>
                eqbtn.equipment_id == button.equipment_id &&
                eqbtn.device_id == button.device_id,
            );
            if (btn) {
              setEquipmentButtons((equipment_buttons) =>
                equipment_buttons.map((equipment_button) => {
                  if (
                    equipment_button.equipment_id == button.equipment_id &&
                    equipment_button.device_id == button.device_id
                  ) {
                    equipment_button.digit = button.digit;
                    equipment_button.name = `H${button.digit + 1}`;
                  }
                  return equipment_button;
                }),
              );
            } else {
              buttons.push({
                id: button.id,
                equipment_id: button.equipment_id,
                device_id: button.device_id,
                name: `H ${button.digit + 1}`,
                digit: button.digit,
                data1: null,
                data2: null,
                data3: null,
                data4: null,
                data5: null,
              });
              setEquipmentButtons(buttons);
            }
          });
          handleCheckAccess(
            "/room/humidity/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "WIRELESS-KEY") {
      data = [];
      digits = [];
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        names: outputsName,
        digits,
        datas: data,
        type: 99,
      })
        .then(({ data }) => {
          let buttons = [
            ...equipmentButtons,
            {
              id: data.equipment_button.id,
              equipment_id: eq_id,
              device_id: selectedDevice,
              name: outputsName[0],
              digit: null,
            },
            // {
            //   equipment_id: eq_id,
            //   device_id: selectedDevice,
            //   name: outputsName[0],
            //   digit: data.equipment_button.id,
            // },
            // {
            //   equipment_id: eq_id,
            //   device_id: selectedDevice,
            //   name: outputsName[0],
            //   digit: data.equipment_button.id,
            // },
          ];

          data.equipment_buttons.forEach((button) => {
            buttons.push({
              id: button.id,
              equipment_id: button.equipment_id,
              device_id: button.device_id,
              name: button.name,
              digit: button.digit,
              data1: button.data1,
              data2: button.data2,
              data3: button.data3,
              data4: button.data4,
              data5: button.data5,
            });
          });

          setEquipmentButtons(buttons);
          handleCheckAccess(
            "/room/wireless-key/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "SCENARIO-KEY") {
      let selected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      let states = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      outputsName.map((out) => {
        selected[out - 1] = 1;
      });
      outputStates.map((state, index) => {
        if (state == 1) {
          states[index] = 1;
        } else {
          states[index] = 0;
        }
      });

      // Join the arrays into binary strings and reverse them
      let selectedBin = selected.join("").split("").reverse().join("");
      let statesBin = states.join("").split("").reverse().join("");

      // Ensure each binary string is 16 bits (2 bytes)
      selectedBin = selectedBin.padEnd(16, "0");
      statesBin = statesBin.padEnd(16, "0");

      // Split the binary strings into 2 bytes (8 bits per byte)
      let stateBytes = [statesBin.slice(0, 8), statesBin.slice(8, 16)];
      let selectedBytes = [selectedBin.slice(0, 8), selectedBin.slice(8, 16)];

      // Convert each byte to decimal
      stateBytes = stateBytes.map((byte) => parseInt(byte, 2));
      selectedBytes = selectedBytes.map((byte) => parseInt(byte, 2));

      // Combine into final array (2 bytes for states first, then 2 bytes for selected)
      let data = [...stateBytes, ...selectedBytes];

      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        datas: data,
        type: 401,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          data.equipment_buttons.forEach((button) => {
            buttons.push({
              id: button.id,
              equipment_id: button.equipment_id,
              device_id: button.device_id,
              digit: button.digit,
              name: button.name,
              data1: button.data1,
              data2: button.data2,
              data3: button.data3,
              data4: button.data4,
              data5: button.data5,
            });
          });
          setEquipmentButtons(buttons);
          handleCheckAccess(
            "/room/scenario-key/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "INPUT") {
      data = [];
      digits = outputsName.map((out) => out - 1);
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        datas: data,
        digits,
        type: 9998,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          // digits.forEach((digit) => {
          //   if (digit < 12) {
          //     buttons.push({
          //       equipment_id: eq_id,
          //       device_id: selectedDevice,
          //       digit,
          //       name: digit + 1,
          //       data1: null,
          //       data2: null,
          //       data3: null,
          //       data4: null,
          //       data5: null,
          //     });
          //   } else {
          //     buttons.push({
          //       equipment_id: eq_id,
          //       device_id: selectedDevice,
          //       digit,
          //       name: `سناریو ${digit - 11}`,
          //       data1: null,
          //       data2: null,
          //       data3: null,
          //       data4: null,
          //       data5: null,
          //     });
          //   }
          // });

          data.equipment_buttons.forEach((button) => {
            if (button.digit < 12) {
              buttons.push({
                id: button.id,
                equipment_id: button.equipment_id,
                device_id: button.device_id,
                digit: button.digit,
                name: `ورودی ${button.digit + 1}`,
                data1: null,
                data2: null,
                data3: null,
                data4: null,
                data5: null,
              });
            } else {
              buttons.push({
                id: button.id,
                equipment_id: button.equipment_id,
                device_id: button.device_id,
                digit: button.digit,
                name: `سناریو ${button.digit - 11}`,
                data1: null,
                data2: null,
                data3: null,
                data4: null,
                data5: null,
              });
            }
          });
          setEquipmentButtons(buttons);
          handleCheckAccess(
            "/room/input/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "INPUT-STATUS") {
      data = [];
      digits = outputsName.map((out) => out - 1);
      setIsLoading(true);
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        datas: data,
        digits,
        type: 9999,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          // digits.forEach((digit) => {
          //   if (digit < 12) {
          //     buttons.push({
          //       equipment_id: eq_id,
          //       device_id: selectedDevice,
          //       digit,
          //       name: digit + 1,
          //       data1: null,
          //       data2: null,
          //       data3: null,
          //       data4: null,
          //       data5: null,
          //     });
          //   } else {
          //     buttons.push({
          //       equipment_id: eq_id,
          //       device_id: selectedDevice,
          //       digit,
          //       name: `سناریو ${digit - 11}`,
          //       data1: null,
          //       data2: null,
          //       data3: null,
          //       data4: null,
          //       data5: null,
          //     });
          //   }
          // });

          data.equipment_buttons.forEach((button) => {
              buttons.push({
                id: button.id,
                equipment_id: button.equipment_id,
                device_id: button.device_id,
                digit: button.digit,
                name: button.name,
                data1: null,
                data2: null,
                data3: null,
                data4: null,
                data5: null,
              });
          });
          setEquipmentButtons(buttons);
          handleCheckAccess(
            "/room/input-status/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (equipmentDetail.name == "DATA-LOGGER") {
      setIsLoading(true);
      let dataLoggerData = DataLoggerPropertiesRef.current.getData();
      let digit = dataLoggerData.slaveAddress;
      let data1 = dataLoggerData.functionCode;
      let data2 = splitIntoTwoBytes(dataLoggerData.dataAddress)[0];
      let data3 = splitIntoTwoBytes(dataLoggerData.dataAddress)[1];
      let data4 = dataLoggerData.quantity;
      let data5 = null;
      if (dataLoggerData.functionCode == 6) {
        data5 = parseInt(
          dataLoggerData.multipliedBy.toString(2).padStart(8, "0"),
          2,
        );
      }
      let data = [data1, data2, data3, data4, data5];
      CreateEquipmentButton({
        equipment_id: eq_id,
        device_id: selectedDevice,
        datas: data,
        digit,
        type: 600,
      })
        .then(({ data }) => {
          let buttons = [...equipmentButtons];
          data.equipment_buttons.forEach((button) => {
            buttons.push({
              id: button.id,
              equipment_id: button.equipment_id,
              device_id: button.device_id,
              digit: button.digit,
              name: button.name,
              data1: button.data1,
              data2: button.data2,
              data3: button.data3,
              data4: button.data4,
              data5: button.data5,
            });
          });
          setEquipmentButtons(buttons);
          handleCheckAccess(
            "/room/data-logger/" + roomId + "/" + eq_id + "/" + eq_type,
            buttons,
          );
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          ErrorToast(err.response.data.message);
        });
    }
    setUpdate((prev) => !prev)
  };

  const splitIntoTwoBytes = (number) => {
    if (number < 0 || number > 65535) {
      throw new Error("عدد باید بین 0 تا 65535 باشد");
    }

    const lowByte = number & 0xff; // بایت اول (8 بیت پایین)
    const highByte = (number >> 8) & 0xff; // بایت دوم (8 بیت بالا)

    return [highByte, lowByte]; // اول high، بعد low
  };

  const handleCheckAccess = (navigateUrl, buttons = []) => {
    // setIsLoading(true);
    // ShowEquipment({
    //   equipment_id: eq_id,
    // })
    //   .then(({ data }) => {
    //     if (data.equipment?.buttons.length) {
    //       navigate(navigateUrl);
    //     } else {
    //       setSelectedEquipment({
    //         id: eq_id,
    //         type: eq_type,
    //       });
    //       navigate(
    //         "/room/select-device/" + roomId + "/" + eq_id + "/" + eq_type
    //       );
    //     }
    //     setIsLoading(false);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // let buttons = equipmentButtons.filter((eq) => eq.equipment_id == eq_id);
    if (buttons.length) {
      navigate(navigateUrl);
    } else {
      setSelectedEquipment({
        id: eq_id,
        type: eq_type,
      });
      navigate("/room/select-device/" + roomId + "/" + eq_id + "/" + eq_type);
    }
  };

  const handleGetEquipmentDetail = (type) => {
    return EquipmentDevices.find((device) => device.type == type);
  };

  return (
    <div id="selectDevice">
      <Select2
        parentElem={"#selectDevice"}
        options={options}
        value={selectedDevice}
        setValue={handleChangeSelectedDevice}
      />
      <div className="outputs mt-4 d-flex justify-content-around flex-wrap">
        {eq_type != 600 && renderOutputs()}
      </div>
      {eq_type == 600 && <DataLoggerProperties ref={DataLoggerPropertiesRef} />}
      <div className="row mx-0">
        <div className="col-12 mt-4 text-center">
          <button
            type="button"
            className="btn rounded-pill btn-icon btn-success-app p-3"
            onClick={handleSubmitStates}
          >
            <i className="bx bx-check"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectDevice;
